export interface BrushToggleLabels {
  on: string
  off: string
}

export const DEFAULT_BRUSH_TOGGLE_LABELS: BrushToggleLabels = {
  on: 'Disable brush selection',
  off: 'Enable brush selection',
}
